import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * A primitive useful for grid layouts. Grid extends from Box with
 * `display: grid` and comes with helpful shorthand styles.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/grid#usage)
 * - [Props](https://blockparty.endpoint.com/components/grid#props)
 * <br />
 *
 */
const Grid = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    gap,
    rowGap,
    columnGap,
    autoFlow,
    autoRows,
    autoColumns,
    templateRows,
    templateColumns,
    templateAreas,
    area,
    column,
    row,
    ...props
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    display: "grid",
    gridArea: area,
    gridAutoColumns: autoColumns,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridColumn: column,
    gridColumnGap: columnGap,
    gridGap: gap,
    gridRow: row,
    gridRowGap: rowGap,
    gridTemplateAreas: templateAreas,
    gridTemplateColumns: templateColumns,
    gridTemplateRows: templateRows
  }, props));
});

export { Grid };
